import React from "react";

const Wrapper = ({ children }) => {
  return <div className="px-6 mt-4">{children}</div>;
};

export default Wrapper;
